class MiniCart extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
  const detailsElement = this.drawer.querySelector('details');
  if (detailsElement && detailsElement.hasAttribute('open')) {
    detailsElement.removeAttribute('open');
  }
  this.drawer.openMenuDrawer();
}

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);

class GkSetComplete extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onActivate.bind(this));
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.onActivate();
      }
    });
  }

  onActivate() {
    if (this.hasAttribute('disabled')) return;
    this.setAttribute('disabled', '');
    this.classList.add('loading');

    const addVariantId = parseInt(this.dataset.addVariantId, 10);
    const removeVariantId = parseInt(this.dataset.removeVariantId, 10);
    let removedUnit = false;

    // Zu entfernende Position live aus dem Warenkorb bestimmen (nie aus dem
    // gerenderten HTML — das kann veraltet sein). Reihenfolge bewusst:
    // erst entfernen, dann Set hinzufuegen. /cart/change revalidiert den
    // gesamten Warenkorb und wirft dabei Positionen mit knappem Bestand raus —
    // das frisch hinzugefuegte Set waere sonst gefaehrdet.
    fetch(`${theme.routes.cart_url}.js`, { headers: { 'Accept': 'application/json' } })
      .then((response) => response.json())
      .then((cart) => {
        const line = cart.items.find(
          (item) => item.variant_id === removeVariantId && item.variant_id !== addVariantId
        );
        if (!line) return null;
        removedUnit = true;
        const changeBody = JSON.stringify({ id: line.key, quantity: line.quantity - 1 });
        return fetch(`${theme.routes.cart_change_url}`, { ...fetchConfig('javascript'), body: changeBody })
          .then((response) => response.json());
      })
      .then(() => {
        const addBody = JSON.stringify({ id: addVariantId, quantity: 1 });
        return fetch(`${theme.routes.cart_add_url}`, { ...fetchConfig('javascript'), body: addBody })
          .then((response) => response.json());
      })
      .then((response) => {
        if (response.status === 422) {
          // Set nicht mehr verfuegbar: entfernte Einheit zuruecklegen
          if (removedUnit) {
            const rollback = JSON.stringify({ id: removeVariantId, quantity: 1 });
            return fetch(`${theme.routes.cart_add_url}`, { ...fetchConfig('javascript'), body: rollback });
          }
          throw new Error(response.description);
        }
        return null;
      })
      .then(() => {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.removeAttribute('disabled');
        this.classList.remove('loading');
      });
  }
}

customElements.define('gk-set-complete', GkSetComplete);
